<template>
  <div class="wrap">
    <Navbar :title="configs.title || ''">
      <template #right>
        <i class="iconfont nav_tools_item" v-for="(item, index) in navTools" :key="`tool_${index}`" :class="item.icon"
          @click="item.click"></i>
      </template>
    </Navbar>
    <div class="content">
      <div class="content_top">
        <div class="_top">
          <div class="money">{{ $t('钱包总余额') }}</div>
          <div class="money_num">{{ userInfo.money }}
            <van-icon name="replay" color="var(--light)" />
          </div>
        </div>
        <div class="btns">
          <div class="btn" @click="toWithdraw">{{ $t('btn.withdraw') }}</div>
          <div class="btn" @click="toRecharge">{{ $t('订金') }}</div>
        </div>
      </div>
      <div class="conts">
        <div class="merchants">
          <div class="merchants_tab">
            <div class="tab_item" :class="activeNum == index ? 'active_item' : ''" v-for="item, index in merchants"
              :key="index" @click="merchantsClick(item)">
              {{ item.subtitle }}
            </div>
          </div>
          <div class="merchants_cont">
            <div class="cont_left">
              <div class="title">{{ configs.subtitle }}</div>
              <div class="value">{{ orderLists[0] && orderLists[0].expect }}</div>
            </div>
            <div class="cont_right">
              <div class="title">{{ $t('倒计时') }}</div>
              <div class="time">
                <template v-if="countTime > 0">
                  <div :class="index == 2 ? 'num' : 'time_num'" v-for="item, index in countText.split('')" :key="index">
                    {{ item }}
                  </div>
                </template>
                <div v-else class="opening_text">{{ $t('status.open') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="game">
          <div class="gameBtn">
            <div class="btn green" @click="gameClick('green')">
              {{ $t('绿') }}<br />
              {{ method['hl-sb'] }}
            </div>
            <div class="btn violet" @click="gameClick('violet')">{{ $t('紫') }}<br />{{ method['hl-sb-z'] }}</div>
            <div class="btn red" @click="gameClick('red')">{{ $t('红') }}<br />{{ method['hl-sb'] }}</div>
          </div>
          <div class="gameNums">
            <div class="img_list" v-for="index in 10"
              :key="index" @click="gameNumClick(index - 1)">
              <div class="_img" :class="gameNumArr.includes(index - 1) ? 'img_active' : ''">
                <img class="img"
                  :class="[isActive && randomNum == (index - 1) ? 'activeRandom' : '', (numberSequenceTimer || numberSequencePaused) && numberSequence == index - 1 ? 'numberSequenceActive' : '', numberSequencePaused && numberSequence == index - 1 ? 'numberSequencePaused' : '']"
                  :src="require(`../../../assets/new/game/qq_${index - 1}.png`)">
              </div>
              <span :style="gameNumArr.includes(index - 1) && {opacity: .3}">
                {{ method['hl-dwd'] }}
              </span>
              </div>
          </div>
          <div class="game_submit" @click="gameSubmit">{{ $t('newAdd.Submit') }}</div>
          <div class="multiple">
            <div class="random" @click="randomClick">{{ $t('random') }}</div>
            <div class="multiple_">
              <div class="_list" :class="item == multipleListActive ? '_list_active' : ''"
                v-for="item, index in multipleList" :key="index" @click="multiplelistClick(item)">
                x{{ item }}
              </div>
            </div>
          </div>
          <div class="btnsize">
            <div class="btn big" @click="gameClick('big')">
              {{ $t('open.big') }}
              <span>{{ method['dxds'] }}</span>
            </div>
            <div class="btn small" @click="gameClick('small')">
              {{ $t('open.small') }}
              <span>{{ method['dxds'] }}</span>
            </div>
          </div>
        </div>
        <div class="game_tab">
          <div class="tab_item" :class="index == tabActive ? 'tab_item_active' : ' '" v-for="item, index in tabList"
            :key="index" @click="tabClick(index)">
            {{ $t(item) }}
          </div>
        </div>
        <div class="game_order">
          <template v-if="tabActive == 0">
            <div class="order_title">
              <div class="td first">{{ $t('下注期号') }}</div>
              <div class="td second">{{ $t('下注号码') }}</div>
              <div class="td second">{{ $t('大/小') }}</div>
              <div class="td last">{{ $t('颜色') }}</div>
            </div>
            <div class="order_list">
              <game-history isNav :type="type" ref="gameHistoryRef">
                <template v-slot:item="{ item }">
                  <div class="_list">
                    <div class="td first">{{ item.expect }}</div>
                    <div class="td second">{{ item.code }}</div>
                    <div class="td second">{{ item.open && (Number(item.open['hl-dwd']) > 4 ? $t('大') : $t('小')) }}
                    </div>
                    <div class="td last">
                      <div class="last_round" v-if="item.open.dxds">
                        <div class="round" v-if="item.open['hl-dwd'] == 0">
                          <div class="round_red"></div>
                          <div class="round_violet"></div>
                        </div>
                        <div class="round" v-else-if="item.open['hl-dwd'] == 5">
                          <div class="round_green"></div>
                          <div class="round_violet"></div>
                        </div>
                        <div class="round" v-else-if="Number(item.open['hl-dwd']) % 2 == 0">
                          <div class="round_red"></div>
                        </div>
                        <div class="round" v-else-if="Number(item.open['hl-dwd']) % 2 == 1">
                          <div class="round_green"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </game-history>
            </div>
          </template>
          <template v-else>
            <gameOrder ref="gameOrderRef" :type="type" />
          </template>
        </div>
      </div>
    </div>
    <van-popup v-model="show" :class="show ? 'bottom_pop' : ''" position="bottom">
      <div class="popup_content">
        <div class="popup_top" :style="{ ...styles }">
          <div class="top_title">{{ configs.title }}</div>
          <div class="select">
            <div>{{ $t('game.select') }}</div>
            <div class="select_text">{{ select_text }}</div>
          </div>
        </div>
        <div class="popup_comin">
          <div class="amount">
            <div class="left">{{ $t('label.amount') }}</div>
            <div class="right">
              <div class="list">
                <div class="list_num" :style="amountActive == item ? { ...selectBg, color: 'var(--light)' } : {}"
                  v-for="item, index in amountArr" :key="index" @click=amountClick(item)>
                  {{ item }}
                </div>
                <div class="list_num balance_percent" :style="amountActive == balancePercent ? { ...selectBg, color: 'var(--light)' } : {}"
                  @click="amountClick(balancePercent)">
                  {{$t('余额1%')}}
                </div>
              </div>
            </div>
          </div>
          <div class="amount quantity">
            <div class="left">{{ $t('game.quantity') }}</div>
            <div class="right">
              <div class="number">
                <div class="btn reduce" :style="selectBg" @click="amountReduce">-</div>
                <Field v-model="multipleListActive" type="number" input-align="center" />
                <div class="btn add" :style="selectBg" @click="amountAdd">+</div>
              </div>
            </div>
          </div>
          <div class="amount">
            <div></div>
            <div class="list">
              <div class="list_num" v-for="item, index in multipleList" :key="index" @click="multiplelistClick(item)"
                :style="multipleListActive == item ? { ...selectBg, color: '#fff' } : {}">X{{ item }}</div>
            </div>
          </div>
        </div>
        <div class="agree">
          <van-checkbox v-model="checked" shape="square" checked-color="var(--bg)">
            <span class="agree_text">{{ $t('我同意') }}</span>
            <span class="agree_desc" @click="showRule = true">{{ $t('游戏规则') }}</span>
          </van-checkbox>
        </div>
        <div class="popup_footer">
          <div class="cancel" @click="cancelClick">{{ $t('newAdd.Cancel') }}</div>
          <div class="amount" :style="selectBg" @click="endClick">{{ $t('game.totalAmount') }} {{ $money(allmount) }}
            (BET)
          </div>
        </div>
      </div>
    </van-popup>
    <Dialog v-model="showRule" :title="$t('游戏规则')" show-cancel-button :show-confirm-button="false"
      :cancel-button-text="$t('btn.cancel')">
      <div class="rule_cont" v-html="ruleContent"></div>
    </Dialog>

    <Dialog v-model="dialogShow" class="wins" :show-confirm-button="false">
      <img src="../../../assets/new/game/dialog.png" alt="">
      <div class="win_cont">
        <div class="title">{{ $t('你赢了') }}</div>
        <div class="subtitle">{{ $t('赢了') }} <span>{{ last_win }}</span> !</div>
        <div class="btn" @click="dialogSubmit">{{ $t('My.Button.Two') }}</div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { $post, $get } from "@/utils/request";
import { post } from "@/utils/newRequest";
import Navbar from "@/components/JNav";
import gameHistory from "../game_record.vue";
import gameOrder from "./components/order.vue";
import { lotterySend } from "@/api";
import {
  cookie,
  LOTTERY_OPENING_EVENT,
  LOTTERY_ORDER_SETTLED_EVENT,
  LOTTERY_RESULT_EVENT,
  subscribeLotteryUser
} from "@/utils";
import {
  NavBar,
  cell,
  icon,
  Field,
  Dialog,
  Toast,
  Tab,
  Tabs,
  Popup,
  Checkbox
} from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
    [icon.name]: icon,
    [Popup.name]: Popup,
    Toast,
    Navbar,
    Dialog: Dialog.Component,
    gameHistory,
    gameOrder,
    Field,
    [Checkbox.name]: Checkbox
  },
  data() {
    this.receivedLotteryResults = Object.create(null);
    this.navTools = [
      {
        icon: "icon-f4f5f8",
        title: "rule",
        click: () => {
          this.showRule = true;
        },
      },
      {
        icon: "icon-guizeguanli",
        title: "record",
        click: () => {
          this.toRecord();
        },
      },
    ];
    return {
      configs: {},
      rightShow: false,
      orderLists: [],
      selectArr: [],
      perPrice: "",
      userInfo: {},
      interval: null,
      countText: "00:00",
      countTime: 0,
      buyShow: false,
      orderShow: false,
      games: [],
      dxdsConfig: {},
      numSelectArr: [],
      ruleContent: "",
      showRule: false,
      txffcGames: [],
      txffcSelectData: {},
      currentGame: {},
      dxdsArr: [],
      isFindIndex: '',
      newDxdsArr: [],
      newResultDxds: {},
      newDxdsCode: ['', '', '', '', ''],
      timer: null,
      dailyBet: 0,
      dailyWin: 0,
      lastCurrent: {},
      num: -1,
      qqSelectArr: [],
      type: this.$route.query.type,
      multipleList: [1, 10, 20, 50, 100],
      multipleListActive: 1,
      tabList: ['游戏历史', '我的下注'],
      tabActive: 0,
      gameNumArr: [],
      randomNum: '',
      isActive: false,
      show: false,
      styles: {},
      selectBg: {},
      amountArr: [1, 5, 10, 50, 100, 500, 1000, 2000, 3000, 5000, 10000, 50000],
      amountActive: 1,
      select_text: "",
      checked: true,
      dialogArr: [],
      dialogShow: false,
      last_win: 0,
      isVisible: true,
      numberSequence: 0,
      numberSequenceTimer: null,
      numberSequenceResumeTimer: null,
      numberSequencePaused: false,
      method:{},
      countdownZeroHandled: false,
      countdownSocketStarted: false,
      countdownSocketVersion: 0
    };
  },
  created() {
    // 首次数据仍由接口初始化；后续期号、倒计时由全局 WebSocket 通知。
    Promise.all([this.getRoomData(), this.getOrders()]);
    this.getUserInfo();
  },
  mounted() {
    window.scrollTo(0, 0);
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    window.addEventListener(LOTTERY_OPENING_EVENT, this.handleLotteryOpening)
    window.addEventListener(LOTTERY_RESULT_EVENT, this.handleLotteryResult)
    window.addEventListener(LOTTERY_ORDER_SETTLED_EVENT, this.handleLotteryOrderSettled)
  },
  computed: {
    allmount() {
      let length = 1;
      if (this.gameNumArr.length) {
        length = this.gameNumArr.length
      }
      return this.amountActive * this.multipleListActive * length
    },
    balancePercent() {
      const balance = Number(this.userInfo.money);
      if (!Number.isFinite(balance) || balance <= 0) return 0;
      return Math.floor(balance * 0.01);
    },
    activeNum() {
      return this.merchants.findIndex(item => item.type == this.type);
    },
    merchants() {
      let game = this.$store.getters.AllGameList;
      return game.filter(item => item.type.includes('qq') > 0)
    },
  },
  methods: {
    compareExpect(left, right) {
      const leftValue = String(left || '');
      const rightValue = String(right || '');
      if (/^\d+$/.test(leftValue) && /^\d+$/.test(rightValue)) {
        const normalizedLeft = leftValue.replace(/^0+(?=\d)/, '');
        const normalizedRight = rightValue.replace(/^0+(?=\d)/, '');
        if (normalizedLeft.length !== normalizedRight.length) {
          return normalizedLeft.length > normalizedRight.length ? 1 : -1;
        }
        if (normalizedLeft === normalizedRight) return 0;
        return normalizedLeft > normalizedRight ? 1 : -1;
      }
      return leftValue.localeCompare(rightValue);
    },
    handleLotteryOpening(event) {
      const opening = event && event.detail;
      if (!opening || !opening.type || !opening.expect) return;
      if (String(opening.type) !== String(this.type)) return;

      const expect = String(opening.expect);
      const currentExpect = this.currentGame && this.currentGame.expect !== undefined
        ? String(this.currentGame.expect)
        : '';
      if (currentExpect && this.compareExpect(expect, currentExpect) < 0) return;

      const endtime = Number(opening.endtime);
      const serverTime = Number(opening.server_time);
      if (!Number.isFinite(endtime) || !Number.isFinite(serverTime)) return;

      const countdown = Math.max(0, Math.floor(endtime - serverTime));
      const current = {
        ...this.currentGame,
        ...opening,
        expect,
        countdown,
      };

      this.countdownSocketStarted = true;
      this.countdownSocketVersion += 1;
      this.currentGame = current;
      if (this.orderLists.length) {
        this.$set(this.orderLists, 0, {
          ...this.orderLists[0],
          ...current,
        });
      } else {
        this.orderLists = [current];
      }

      this.addInterval(countdown);
    },
    handleLotteryResult(event) {
      const result = event && event.detail;
      if (!result || !result.type || !result.expect || result.code === undefined) return;
      if (String(result.type) !== String(this.type)) return;

      const expect = String(result.expect);
      const lastExpect = this.lastCurrent && this.lastCurrent.expect !== undefined
        ? String(this.lastCurrent.expect)
        : '';
      if (lastExpect && this.compareExpect(expect, lastExpect) < 0) return;

      const key = `${result.type}:${expect}`;
      if (this.receivedLotteryResults[key]) return;
      this.receivedLotteryResults[key] = true;
      const resultNumber = Number(String(result.code).trim());
      if (!Number.isInteger(resultNumber) || resultNumber < 0 || resultNumber > 9) return;

      const historyItem = {
        ...result,
        type: String(result.type),
        expect,
        code: String(result.code),
        status: '已开奖',
        countdown: 0,
        open: {
          'hl-dwd': resultNumber,
          'hl-sb': resultNumber === 0
            ? ['紫', '红']
            : resultNumber === 5
              ? ['紫', '绿']
              : [resultNumber % 2 === 0 ? '红' : '绿'],
          dwd: [String(resultNumber)],
          dxds: [{
            zh: resultNumber,
            dx: resultNumber > 4 ? '大' : '小',
            ds: resultNumber % 2 === 0 ? '双' : '单',
          }],
        },
      };

      this.lastCurrent = { ...this.lastCurrent, ...historyItem };
      this.pauseNumberSequence(resultNumber, expect);
      this.$refs.gameHistoryRef && this.$refs.gameHistoryRef.applyLotteryResult(historyItem);
      this.num = 0;
    },
    handleLotteryOrderSettled(event) {
      const settlement = event && event.detail;
      if (!settlement || !settlement.type || !settlement.expect || !Array.isArray(settlement.orders)) return;

      const balance = Number(settlement.balance);
      if (Number.isFinite(balance)) {
        this.$set(this.userInfo, 'money', balance);
        this.user_money = balance;
      }

      // 余额对所有彩种实时更新，中奖弹窗只处理当前正在展示的彩种。
      if (String(settlement.type) !== String(this.type)) return;

      const expect = String(settlement.expect);
      const totalWin = settlement.orders.reduce((total, order) => {
        const winMoney = Number(String(order && order.winMoney !== undefined
          ? order.winMoney
          : 0).replace(/,/g, ''));
        return Number(total) + (Number.isFinite(winMoney) && winMoney > 0 ? winMoney : 0);
      }, 0);
      const roundedTotalWin = Number(totalWin.toFixed(2));
      if (roundedTotalWin <= 0) return;

      const arrItem = `${settlement.type}${expect}`;
      let gameExpect = {};
      try {
        gameExpect = JSON.parse(cookie.get('gameExpect') || '{}');
      } catch (error) {
        gameExpect = {};
      }
      if (this.dialogArr.includes(arrItem) || String(gameExpect[settlement.type] || '') === expect) return;

      this.lastCurrent = {
        ...this.lastCurrent,
        type: String(settlement.type),
        expect,
        code: settlement.code,
      };
      this.last_win = roundedTotalWin.toFixed(2);
      this.dialogShow = true;
      cookie.set('gameExpect', JSON.stringify({
        ...gameExpect,
        [settlement.type]: expect,
      }));
    },
    startNumberSequence() {
      if (this.numberSequenceTimer || this.numberSequencePaused) return;
      clearInterval(this.numberSequenceTimer);
      this.numberSequenceTimer = setInterval(() => {
        this.numberSequence = (this.numberSequence + 1) % 10;
      }, 180);
    },
    stopNumberSequence() {
      clearInterval(this.numberSequenceTimer);
      this.numberSequenceTimer = null;
    },
    pauseNumberSequence(result, expect) {
      const resultNumber = Number(result);
      if (!Number.isInteger(resultNumber) || resultNumber < 0 || resultNumber > 9) return;
      clearInterval(this.numberSequenceTimer);
      clearTimeout(this.numberSequenceResumeTimer);
      this.numberSequence = resultNumber;
      this.numberSequencePaused = true;
      this.numberSequenceResumeTimer = setTimeout(() => {
        if (this.countTime > 0 && this.countTime <= 10) {
          this.numberSequencePaused = false;
          this.startNumberSequence();
        } else {
          this.numberSequencePaused = false;
        }
      }, 3000);
      this.numberSequenceResultExpect = expect;
    },
    handleVisibilityChange() {
      this.isVisible = !document.hidden;
      if (!this.isVisible) { } else {
        this.getRoomData();
        // 长连接接管后，页面恢复也不再请求当前期/上一期的 pagesize=2 接口。
        if (!this.countdownSocketStarted) this.getOrders();
        this.getUserInfo();
        if (this.tabActive == 0) {
          this.$refs.gameHistoryRef && this.$refs.gameHistoryRef.getList(true, 1);
        }
      }
    },
    amountClick(item) {
      this.amountActive = item;
    },
    cancelClick() {
      this.show = false;
    },
    getcodeMethod() {
      let obj = {};
      let randomNum = this.randomNum;
      if (randomNum == 0) {
        randomNum = 0
      }
      switch (randomNum) {
        case 'red':
          obj.method = 'hl-sb';
          obj.code = '红'
          break;
        case 'green':
          obj.method = 'hl-sb';
          obj.code = '绿'
          break;
        case 'violet':
          obj.method = 'hl-sb-z';
          obj.code = '紫'
          break;
        case 'big':
          obj.method = 'dxds';
          obj.code = '大'
          break;
        case 'small':
          obj.method = 'dxds';
          obj.code = '小'
          break;
        default:
          obj.method = 'hl-dwd';
          obj.code = randomNum
          break;
      }
      return obj
    },
    endClick() {
      if (!this.countTime) {
        this.$toast(this.$t("hint.opening"));
        return;
      }
      Dialog.confirm({
        message: this.$t("hint.confirmBet"),
        cancelButtonText: this.$t("My.Button.One"),
        confirmButtonText: this.$t("My.Button.Two"),
      }).then(() => this.sendlottery()).catch(() => {});
    },
    async sendlottery() {
      const { method, code } = this.getcodeMethod();
      try {
        const res = await lotterySend({
          expect: this.orderLists[0].expect,
          money: this.amountActive * this.multipleListActive,
          code,
          method,
          type: this.type,
          mtype: 'yuan'
        });
        Toast(res.msg);
        this.$nextTick(() => {
          this.gameNumArr = [];
          this.randomNum = "";
          this.show = false;
          this.multipleListActive = 1;
          this.amountActive = 5;
          this.getUserInfo();
          if (this.tabActive == 1) {
            this.$refs.gameOrderRef && this.$refs.gameOrderRef.getList(true);
          }
        })
      } catch (error) {
        Toast(error.msg, 'error')
      }
    },
    amountReduce() {
      if (this.multipleListActive <= 1) return;
      this.multipleListActive--;
    },
    amountAdd() {
      this.multipleListActive++;
    },
    gameNumClick(index) {
      let arr = JSON.parse(JSON.stringify(this.gameNumArr));
      if (arr.includes(index)) {
        arr = arr.filter(num => num !== index);
      } else {
        if (arr.length > 6) return Toast(this.$t('数字最多选择', { num: 7 }))
        arr.push(index);
      }
      this.gameNumArr = arr;
      this.randomNum = arr.join('')
    },
    tabClick(index) {
      this.tabActive = index;
    },
    multiplelistClick(index) {
      this.multipleListActive = index;
    },
    gameSubmit() {
      if (!this.gameNumArr.length) return Toast(this.$t('game.selectNum'), 'none');
      this.selectText(this.randomNum)
      this.select_text = this.randomNum.toString().split('').join(',')
      this.show = true;
    },
    randomClick() {
      let intervalId = null;
      let randomNum;
      this.isActive = true;
      intervalId = setInterval(() => {
        randomNum = Math.floor(Math.random() * 10);
        this.randomNum = randomNum;
      }, 100);
      setTimeout(() => {
        clearInterval(intervalId);
        this.isActive = false;
        this.gameClick(randomNum)
      }, 1000);
    },
    gameClick(text) {
      this.gameNumArr = []
      this.randomNum = text;
      this.select_text = this.selectText(text);
      this.show = true;
    },
    selectText(randomNum) {
      if (randomNum == 0) {
        randomNum = randomNum.toString();
      }
      if (randomNum == "") return;
      switch (randomNum) {
        case 'green':
          this.styles = { background: 'linear-gradient(0deg, #4EC129 0%, #95E27A 17%, #6FDE49 38%, #B5FF9B 99%)' }
          this.selectBg = { background: '#95E27A' }
          return this.$t('绿')
          break;
        case 'violet':
          this.styles = { background: 'linear-gradient(180deg, #D675EE 0%, #BE5ED6 62%, #CE72E5 80%, #AA4FF9 100%)' }
          this.selectBg = { background: '#C969E1' }
          return this.$t('紫')
          break;
        case 'red':
          this.styles = { background: 'linear-gradient(180deg, #FF3D3D 0%, #FD3434 46%, #FF6262 76%, #FB2F2F 100%)' }
          this.selectBg = { background: '#FD3434' }
          return this.$t('红')
          break;
        case 'big':
          this.styles = { background: 'linear-gradient(181deg, #FBE599 2%, #F9DB76 49%, #FBE699 71%, #EEB452 97%)' }
          this.selectBg = { background: '#F9DB76' }
          return this.$t('大')
          break;
        case 'small':
          this.styles = { background: 'linear-gradient(0deg, #B5FF9B 0%, #6FDE49 43%, #95E27A 72%, #4EC129 99%)' }
          this.selectBg = { background: '#6FDE49' }
          return this.$t('小')
          break;
        default:
          this.numberColor(randomNum);
          return randomNum
          break;
      }
    },
    numberColor(randomNum) {
      if (Number(randomNum) == 0) {
        this.styles = { background: 'linear-gradient(to bottom right,#FD3434 50%,#C969E1 0)' }
        this.selectBg = { background: '#FD3434' }
      } else if (randomNum == 5) {
        this.styles = { background: 'linear-gradient(to bottom right,#95E27A 50%,#C969E1 0)' }
        this.selectBg = { background: '#95E27A' }
      } else if (randomNum == 1 || randomNum == 3 || randomNum == 7 || randomNum == 9) {
        this.styles = { background: 'linear-gradient(0deg, #4EC129 0%, #95E27A 17%, #6FDE49 38%, #B5FF9B 99%)' }
        this.selectBg = { background: '#95E27A' }
      } else if (randomNum == 2 || randomNum == 4 || randomNum == 6 || randomNum == 8) {
        this.styles = { background: 'linear-gradient(180deg, #FF3D3D 0%, #FD3434 46%, #FF6262 76%, #FB2F2F 100%)' }
        this.selectBg = { background: '#FD3434' }
      } else {
        let arr = randomNum.split('');
        this.numberColor(arr[0])
      }
    },
    merchantsClick(item) {
      if (this.type === item.type) return;
      this.type = item.type;
      this.countdownZeroHandled = false;
      this.countdownSocketStarted = false;
      this.countdownSocketVersion = 0;
      this.$nextTick(() => {
        Promise.all([this.getRoomData(), this.getOrders()]);
        if (this.tabActive == 0) {
          this.$refs.gameHistoryRef && this.$refs.gameHistoryRef.getList(true, 1);
        } else {
          this.$refs.gameOrderRef && this.$refs.gameOrderRef.getList(true);
        }
      })
    },
    toRecord() {
      this.$router.push("cart");
    },
    toRecharge() {
      this.$router.push("/new-recharge");
      return
      Dialog.alert({
        title: this.$t('My.MemberInformation.Recharge'),
        message: this.$t('hint.lxkf'),
        showCancelButton: true,
        confirmButtonText: this.$t('Login.goLoginText'),
        cancelButtonText: this.$t('newAdd.Cancel')
      }).then(() => {
        this.$api.toService();
      }).catch(() => {
      });
      return;
    },
    toWithdraw() {
      this.$router.push("/new-withdraw");
    },
    dialogSubmit() {
      const arrItem = this.type + this.lastCurrent.expect
      this.dialogArr.push(arrItem);
      this.dialogShow = false;
    },
    async getRoomData() {
      const requestedType = String(this.type);
      try {
        const res = await $get("/lottery/setting", {
          type: requestedType,
          explain: 1,
        });
        if (requestedType !== String(this.type)) return;
        const { ret, msg, data } = res.data;
        this.configs = data[0];
        this.ruleContent = this.configs.method_explain;
        this.method = Object.fromEntries(
          this.configs.odds.map(item => [item.method, item.odds])
        );
      } catch (error) {
        console.error(error);
      }
    },
    async getOrders(pageSize = 2, skipCountdown = false, callback = () => { }) {
      Toast.loading();
      const requestedType = String(this.type);
      const socketVersionWhenRequested = this.countdownSocketVersion;
      try {
        const res = await $get("/lottery/lists", {
          type: requestedType,
          pagesize: pageSize,
        });
        // 切换游戏期间返回的旧请求不能覆盖当前 type 的数据。
        if (requestedType !== String(this.type)) {
          Toast.clear();
          return;
        }
        const { ret, msg, data } = res.data;
        const { last_win, last_bet } = data
        const previousLastCurrent = this.lastCurrent;
        // 如果请求过程中刚收到 opening，保留推送的期号和倒计时。
        const preserveSocketCountdown = this.countdownSocketStarted && (
          skipCountdown || this.countdownSocketVersion !== socketVersionWhenRequested
        );
        const socketCurrent = preserveSocketCountdown
          ? { ...this.currentGame, countdown: this.countTime }
          : null;
        const current = socketCurrent
          ? { ...data.lists[0], ...socketCurrent }
          : data.lists[0];
        this.orderLists = socketCurrent
          ? [current, ...data.lists.slice(1)]
          : data.lists;
        this.currentGame = current;
        this.lastCurrent = data.lists[1];
        if (previousLastCurrent.expect && previousLastCurrent.expect !== data.lists[1].expect) {
          this.pauseNumberSequence(data.lists[1].open && data.lists[1].open['hl-dwd'], data.lists[1].expect);
        }
        const arrItem = this.type + data.lists[1].expect
        this.last_win = last_win
        if (this.dialogArr.includes(arrItem)) {
        } else {
          const arrs = JSON.parse(cookie.get('gameExpect') || '{}')
          const findExpect = arrs[this.type]
          if (Number(last_bet) && Number(last_win) > 0 && findExpect != data.lists[1].expect) {
            this.dialogShow = true;
            cookie.set('gameExpect', JSON.stringify({ ...arrs, [this.type]: data.lists[1].expect }))
            // Dialog.alert({
            //   title: this.$t('你赢了'),
            //   message: this.$t('赢了', { money: last_win }),
            //   confirmButtonText: this.$t('Button.confirm')
            // }).then(() => {
            //   this.dialogArr.push(arrItem)
            // });
          }
        }
        callback();
        if (!skipCountdown && !preserveSocketCountdown) {
          this.addInterval(current.countdown);
        }
        this.dailyBet = data.total_bet;
        this.dailyWin = data.total_win;
        this.user_money = data.user_money;
        Toast.clear();
      } catch (error) {
        Toast.clear();
      }
    },
    getUserInfo() {
      if (!this.userInfo.level) {
        this.$api.getUserInfo((res) => {
          this.userInfo = res;
          subscribeLotteryUser(res && res.id, cookie.get('token') || '');
        });
      }
    },
    addInterval(countTime) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null
      }
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null
      }
      this.countTime = Math.max(0, Number(countTime));
      if (this.countTime > 0) this.countdownZeroHandled = false;
      this.syncNumberSequence();
      this.intervalFun();
      if (this.countTime <= 0) return;
      this.interval = setInterval(() => {
        this.countTime = Math.max(0, this.countTime - 1);
        this.intervalFun();
      }, 1000);
    },
    format(num) {
      if (num >= 10) return num;
      else return "0" + num;
    },
    intervalFun() {
      this.countTime = Math.max(0, Number(this.countTime) || 0);
      const hourUnit = 60 * 60;
      const minuteUnit = 60;
      const secondUnit = 1;
      const targetH = Math.floor(this.countTime / hourUnit);
      const targetM = Math.floor((this.countTime % hourUnit) / minuteUnit);
      const targetS = Math.floor(
        ((this.countTime % hourUnit) % minuteUnit) / secondUnit
      );
      if (!this.countTime) {
        clearInterval(this.interval);
        this.interval = null;
        this.handleCountdownComplete();
      }
      this.countText = `${this.format(
        targetM
      )}:${this.format(targetS)}`;
      this.syncNumberSequence();
    },
    handleCountdownComplete() {
      if (this.countdownZeroHandled) return;
      this.countdownZeroHandled = true;
      // 归零后只等待 lottery.opening / lottery.result，不再请求 pagesize=2 接口。
    },
    syncNumberSequence() {
      if (this.countTime > 0 && this.countTime <= 10) {
        this.startNumberSequence();
      } else if (!this.numberSequencePaused) {
        this.stopNumberSequence();
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearTimeout(this.timer);
    clearInterval(this.numberSequenceTimer);
    clearTimeout(this.numberSequenceResumeTimer);
    this.timer = null;
    this.interval = null;
    this.numberSequenceTimer = null;
    this.numberSequenceResumeTimer = null;
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener(LOTTERY_OPENING_EVENT, this.handleLotteryOpening);
    window.removeEventListener(LOTTERY_RESULT_EVENT, this.handleLotteryResult);
    window.removeEventListener(LOTTERY_ORDER_SETTLED_EVENT, this.handleLotteryOrderSettled);
  },
  destroyed() {
    clearInterval(this.interval);
    clearTimeout(this.timer);
    this.timer = null;
    this.interval = null;
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener(LOTTERY_OPENING_EVENT, this.handleLotteryOpening);
    window.removeEventListener(LOTTERY_RESULT_EVENT, this.handleLotteryResult);
    window.removeEventListener(LOTTERY_ORDER_SETTLED_EVENT, this.handleLotteryOrderSettled);
  }
};
</script>

<style lang="less" scoped>
.wrap {
  @import url("@/assets/iconfonts/iconfont.css");
  @bg: var(--black);
  @bgBlod: var(--navTheme);
  @black: var(--navTheme);
  @activeColor: var(--yellow);
  min-height: 100vh;
  background-color: var(--bg);

  /deep/ .van-dialog {
    .van-dialog__header {
      padding: 0;
      line-height: 52px;
      background: var(--bg);
      color: var(--light);
    }

    .van-dialog__content {
      padding: 20px;

      .rule_cont {
        max-height: 60vh;
        overflow-y: scroll;
      }
    }
  }

  .nav_tools_item {
    margin: 0 6px;
    color: var(--light);
    font-size: 20px;

    &:nth-last-of-type(1) {
      margin-right: 0;
    }
  }

  .flex(@position: "") {
    display: flex;
    flex-direction: @position;
  }

  .ver(@position: center) {
    align-items: @position;
  }

  .hor(@position: center) {
    justify-content: @position;
  }

  .nav_left_wrap {
    display: flex;
    align-items: center;

    >.left_title {
      color: var(--textColor);
      margin-left: 5px;
    }
  }

  .content {
    padding: calc(15rem / 16);

    .content_top {
      background: url(../../../assets/new/game/top_bg.png) no-repeat;
      background-size: 100% 100%;
      padding: calc(12rem / 16) calc(16rem / 16);

      ._top {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .money {
          color: rgba(127, 20, 20, 0.8);
          font-size: 14px;
        }

        .money_num {
          color: #7F1414;
          font-size: 18px;
          margin-top: 4px;
        }
      }

      .btns {
        display: flex;
        align-items: center;
        gap: 8px;
        padding-top: calc(24rem / 16);

        .btn {
          flex: 1;
          font-size: 14px;
          text-align: center;
          background-color: var(--navBg);
          border-radius: 50px;
          color: var(--yellow);
          border: 1px solid #FEE182;
          height: 37px;
          line-height: 37px;
          text-transform: uppercase;
        }
      }
    }

    .conts {
      margin-top: calc(20rem / 16);

      .merchants {
        border: 2px solid var(--yellow);
        border-radius: calc(20rem / 16);
        overflow: hidden;

        &_tab {
          display: flex;
          background-color: var(--navBg);

          .tab_item {
            flex: 1;
            max-width: 25%;
            height: calc(45rem / 16);
            font-size: calc(14rem / 16);
            color: var(--light);
            line-height: calc(45rem / 16);
            text-align: center;
            padding: calc(12rem / 16) calc(15ren / 16);
          }

          .active_item {
            background: linear-gradient(181deg, #FBE599 0%, #F9DB76 49%, #FBE699 72%, #EEB452 99%);
            box-shadow: 2px 2px 6px 0px rgba(127, 20, 20, 0.37);
            color: var(--navBg);
          }
        }

        &_cont {
          display: flex;
          justify-content: space-between;
          padding: calc(20rem / 16) calc(12rem / 16);


          .cont_left,
          .cont_right {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex: 1;

            .title {
              color: var(--light);
              font-size: calc(14rem / 16);
            }
          }

          .cont_left {
            width: fit-content;
            border-right: 1px dashed rgba(255, 255, 255, 0.8);
            ;

            .value {
              color: var(--yellow);
              font-size: calc(18rem / 16);
            }
          }

          .cont_right {
            padding-left: calc(20rem / 16);

            .time {
              display: flex;
              align-items: center;
              margin-top: calc(10rem / 16);
              gap: calc(6rem / 16);

              .time_num {
                width: calc(34rem / 16);
                height: calc(34rem / 16);
                border-radius: calc(10rem / 16);
                background: linear-gradient(180deg, #FBE599 0%, #F9DB76 49%, #FBE699 72%, #EEB452 99%);
                box-sizing: border-box;
                border: 1px solid #FEE182;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .num {
                color: var(--yellow);
              }

              .opening_text {
                color: var(--yellow);
                font-size: calc(18rem / 16);
                line-height: calc(34rem / 16);
              }
            }
          }
        }
      }

      .game {
        margin-top: calc(20rem / 16);
        padding: calc(17rem / 16) calc(14rem / 16) calc(34rem / 16);
        border: 2px solid var(--yellow);
        border-radius: calc(20rem / 16);

        .gameBtn {
          display: flex;
          gap: calc(16rem / 16);
          
          .btn {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            flex-direction: row;
            height: calc(50rem / 16);
            padding: 0 calc(15rem / 16);
            color: #780000;
            border-radius: 100px;
            text-align: center;
            font-size: calc(15rem / 16);
            // line-height: calc(43rem / 16);
          }

        }

        .gameNums {
          display: flex;
          flex-wrap: wrap;
          gap: calc(15rem / 16) calc(5rem / 16);
          padding: calc(30rem / 16) 0;

          .img_list {
            width: calc((100% - 20rem / 16) / 5);
            position: relative;
            display: flex;
            flex-direction: column;
            gap: 2px;
            text-align: center;
            color: #fff;
            ._img{
              width: 100%;
              position: relative;
            }
            img {
              width: 100%;
              aspect-ratio: 1 / 1;
              display: block;
            }
          }

          .img_active::before {
            position: absolute;
            content: '';
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .3);
            border-radius: 50%;
            z-index: 1;
          }

          .activeRandom {
            transform: scale(1.1);
          }

          .numberSequenceActive {
            animation: number-sequence-flash 180ms ease-out;
            filter: brightness(1.3) saturate(1.2) drop-shadow(0 0 10px rgba(255, 225, 130, 0.9));
          }

          .numberSequencePaused {
            animation: number-sequence-hold 700ms ease-in-out infinite;
            filter: brightness(1.55) saturate(1.35) drop-shadow(0 0 16px rgba(255, 225, 130, 1));
          }

          @keyframes number-sequence-flash {
            0% {
              transform: scale(1);
            }

            50% {
              transform: scale(1.12);
            }

            100% {
              transform: scale(1.04);
            }
          }

          @keyframes number-sequence-hold {
            0%,
            100% {
              transform: scale(1.06);
              filter: brightness(1.25) saturate(1.15) drop-shadow(0 0 9px rgba(255, 225, 130, 0.8));
            }

            50% {
              transform: scale(1.18);
              filter: brightness(1.7) saturate(1.45) drop-shadow(0 0 22px rgba(255, 225, 130, 1));
            }
          }
        }

        .game_submit {
          height: calc(35rem / 16);
          line-height: calc(35rem / 16);
          border-radius: 100px;
          color: var(--navBg);
          background: linear-gradient(180deg, #FBE599 0%, #F9DB76 49%, #FBE699 72%, #EEB452 99%);
          border: 1px solid #FEE182;
          padding: calc(6rem / 16) calc(15rem / 16);
          text-align: center;
          font-size: calc(15rem / 16);
        }

        .multiple {
          display: flex;
          align-content: center;
          justify-content: space-between;
          margin-top: calc(20rem / 16);

          .random {
            height: 33px;
            line-height: 33px;
            border: 1px solid #FEE182;
            border-radius: 10px;
            font-size: 12px;
            padding: 0 calc(3rem / 16);
            color: var(--yellow);
          }

          .multiple_ {
            display: flex;
            align-items: center;
            gap: calc(5rem / 16);

            ._list {
              width: calc(33rem / 16);
              height: calc(33rem / 16);
              line-height: 33px;
              border: 1px solid #FEE182;
              border-radius: 10px;
              text-align: center;
              color: var(--yellow);
              font-size: 12px;
            }

            ._list_active {
              background: linear-gradient(180deg, #FBE599 0%, #F9DB76 49%, #FBE699 72%, #EEB452 99%);
              color: var(--navBg);
            }
          }
        }

        .btnsize {
          display: flex;
          align-items: center;
          overflow: hidden;
          gap: calc(2rem / 16);
          background-color: var(--light);
          border-radius: 27px;
          margin-top: calc(20rem / 16);

          .btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 2px;
            height: calc(58rem / 16);
            text-align: center;
            font-size: calc(16rem / 16);
            flex: 1;
          }

          .big {
            border-radius: 27px 0 0 27px;
            background: linear-gradient(181deg, #FBE599 2%, #F9DB76 49%, #FBE699 71%, #EEB452 97%);
            box-sizing: border-box;
            border: 1px solid rgba(255, 249, 208, 0.8);
            color: #861E1E;
          }

          .small {
            border-radius: 0 27px 27px 0;
            // color: #186300;
            // background: linear-gradient(0deg, #B5FF9B 0%, #6FDE49 43%, #95E27A 72%, #4EC129 99%);
            color: #861E1E;
            background: linear-gradient(181deg, #FBE599 2%, #F9DB76 49%, #FBE699 71%, #EEB452 97%);
            box-sizing: border-box;
            border: 1px solid rgba(255, 249, 208, 0.8);
          }
        }
      }

      .game_tab {
        display: flex;
        align-items: center;
        margin-top: calc(30rem / 16);
        gap: calc(20rem / 16);

        .tab_item {
          min-width: calc(80rem / 16);
          background: var(--navBg);
          color: rgba(255, 255, 255, 0.8);
          font-size: calc(16rem / 16);
          font-weight: 500;
          padding: calc(8rem / 16) calc(10rem / 16);
          border-radius: 50px;
          text-align: center;
        }

        .tab_item_active {
          background: linear-gradient(181deg, #FBE599 2%, #F9DB76 49%, #FBE699 71%, #EEB452 96%);
          border: 2px solid #FDDD7F;
          color: #7F1414;
        }
      }

      .game_order {
        border: 2px solid var(--yellow);
        border-radius: calc(20rem / 16);
        margin-top: calc(17rem / 16);
        overflow: hidden;

        .order_title {
          padding: calc(20rem / 16) 0;
          display: flex;
          align-items: center;
        }

        .order_list {
          /deep/ .item_wrap {
            padding: 0;
            margin: 0;
            border-radius: 0;
            background: transparent;

            ._list {
              display: flex;
              align-items: center;
              height: calc(45rem / 16);
              line-height: calc(45rem / 16);

              .last {
                &_round {
                  .round {
                    display: flex;
                    column-gap: calc(10rem / 16);

                    div {
                      width: calc(10rem / 16);
                      height: calc(10rem / 16);
                      border-radius: 50%;
                    }

                    .round_red {
                      .red();
                    }

                    .round_green {
                      .green();
                    }

                    .round_violet {
                      .violet();
                    }
                  }
                }
              }
            }
          }

          /deep/ .item_wrap:nth-child(2n+1) {
            ._list {
              background: var(--navBg);
            }
          }
        }

        .td {
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--light);
          font-size: calc(14rem / 16);
        }

        .first {
          flex: 0 0 33.33333333%;
          max-width: 33.33333333%;
        }

        .second,
        .third {
          flex: 0 0 20.83333333%;
          max-width: 20.83333333%;
        }


        .last {
          flex: 0 0 25%;
          max-width: 25%;
        }
      }
    }
  }

  /deep/ .van-popup {
    background-color: transparent;
  }

  .popup_content {
    background-color: var(--light);
    border-radius: 16px 16px 0 0;
    overflow: hidden;

    .popup_top {
      position: relative;
      padding: 15px;
      background: linear-gradient(90deg, #ffa82e 0%, #ffc511 100%);

      .top_title {
        color: var(--light);
        font-size: 18px;
        font-weight: 700;
        text-align: center;
      }

      .select {
        width: 80%;
        margin: 0 auto;
        margin-top: 8px;
        height: 25px;
        border-radius: 8px;
        background-color: var(--light);
        margin-bottom: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333;

        &_text {
          margin-left: 10px;
        }
      }
    }

    .popup_top::after {
      content: "";
      position: absolute;
      width: 50%;
      left: 0;
      bottom: 0;
      height: 30px;
      background-image: linear-gradient(9deg, var(--light) 50%, transparent 50%);
    }

    .popup_top::before {
      content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: 50%;
      height: 30px;
      background-image: linear-gradient(-9deg, var(--light) 50%, transparent 50%);
    }

    .popup_comin {
      padding: 23px 13px;
      background-color: #f0f0f5;

      .amount {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          color: #4d4d4d;
          font-size: 16px;
        }

        .right {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: flex-end;

          .number {
            display: flex;
            align-items: center;
            column-gap: 6px;

            .btn {
              width: 28px;
              height: 28px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: var(--light);
            }

            /deep/ .van-cell {
              width: auto;
              padding: 0 10px;
              line-height: 28px;

              .van-field__control {
                width: 70px;
              }
            }
          }

        }

        .list {
          width: 80%;
          // display: grid;
          // grid-template-columns: repeat(4,1fr);
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 3px;
          flex-wrap: wrap;

          &_num {
            height: 28px;
            padding: 0 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333;
          }
        }
      }

      .quantity {
        margin: 14px 0;
      }
    }

    .agree {
      padding: calc(16rem / 16);
      font-size: calc(14rem / 16);

      .agree_text {
        color: #333;
      }

      .agree_desc {
        color: var(--navBg)
      }
    }

    .popup_footer {
      display: flex;
      font-size: 14px;
      height: 36px;

      .flex {
        display: flex;
        align-items: center;
        justify-content: center
      }

      .cancel {
        flex: 1;
        background-color: var(--bg);
        color: var(--light);
        .flex();
      }

      .amount {
        .flex();
        flex: 1.6;
        color: var(--light);
        background-color: var(--red);
      }

      .share {
        flex: 1.2;
        color: var(--light);
        background-color: #deb86b;
        .flex();
      }
    }
  }

  .wins {
    background: var(--bg);

    /deep/ .van-dialog__content {
      padding: 0;
    }

    img {
      width: 100%;
      height: calc(140rem / 16);
      display: block;
    }

    .win_cont {
      padding: 0 calc(20rem / 16) calc(30rem / 16);

      .title {
        text-align: center;
        font-size: calc(16rem / 16);
        color: var(--light);
      }

      .subtitle {
        color: var(--light);
        margin-top: calc(15rem / 16);
        font-size: calc(14rem / 16);
        text-align: center;

        span {
          font-size: calc(22rem / 16);
          font-weight: 700;
          background: linear-gradient(180deg, #FBE599 0%, #F9DB76 49%, #FBE699 72%, #EEB452 99%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
      }

      .btn {
        width: fit-content;
        margin: 0 auto;
        margin-top: calc(24rem / 16);
        padding: calc(10rem / 16) calc(50rem / 16);
        color: #7F1414;
        line-height: calc(20rem / 16);
        border-radius: 100px;
        font-size: calc(16rem / 16);
        background: linear-gradient(181deg, #FBE599 3%, #F9DB76 49%, #FBE699 70%, #EEB452 95%);
      }
    }
  }
}


.green {
  background: linear-gradient(0deg, #4EC129 0%, #95E27A 17%, #6FDE49 38%, #B5FF9B 99%);
  box-shadow: inset -2px 4px 10px 0px #99FBA6;
}

.violet {
  background: linear-gradient(180deg, #D675EE 0%, #BE5ED6 62%, #CE72E5 80%, #AA4FF9 100%);
  box-shadow: inset -2px 4px 10px 0px #DDB6FF;
}

.red {
  background: linear-gradient(180deg, #FF3D3D 0%, #FD3434 46%, #FF6262 76%, #FB2F2F 100%);
  box-shadow: inset -2px 4px 10px 0px #F78E8E;
}
</style>
